// extracted by mini-css-extract-plugin
export default {"collapse":"faq_collapse__AgUwg"};